import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#d32f2f', // Основной красный цвет
      light: '#ff6659', // Светлый вариант
      dark: '#9a0007',  // Темный вариант
      contrastText: '#ffffff', // Цвет текста на красном фоне
    },
    secondary: {
      main: '#f50057', // Дополнительный цвет (можно оставить розовый/малиновый)
      light: '#ff5983',
      dark: '#bb002f',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff', // Белый фон
      paper: '#f5f5f5',   // Светло-серый для карточек
    },
    text: {
      primary: '#212121', // Основной текст - почти черный
      secondary: '#757575', // Вторичный текст - серый
    },
    error: {
      main: '#f44336', // Цвет ошибок
    },
    warning: {
      main: '#ff9800', // Цвет предупреждений
    },
    success: {
      main: '#4caf50', // Цвет успеха
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    button: {
      textTransform: 'none', // Кнопки без CAPS
    },
  },
  shape: {
    borderRadius: 8, // Закругление углов
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#b71c1c',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          background: 'linear-gradient(45deg, #d32f2f 30%, #9a0007 90%)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
  },
});

export default theme;